import React from 'react';
import translate from 'react-i18next/dist/commonjs/translate';
import { Row, Col } from 'react-flexbox-grid';
import { PreviewTransactionsList, TransactionsSummary} from '../components';
import { connect } from 'react-redux';
import DatePicker from 'antd/lib/date-picker';
import { OpenFileLink } from '../../../common/components/data-display';
import { selectToken, selectAccount } from '../../../features/auth/ducks';
import moment from 'moment';
import { accountRoles } from '../../../common/enums';


const { RangePicker, MonthPicker } = DatePicker;
const mapStateToProps = state => ({
  token: selectToken(state),
  account: selectAccount(state)

});


@translate()
@connect(mapStateToProps)
export default class TransactionsPreviewContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      taxDates: {
        from: moment.utc().subtract(1, 'year').startOf('month').toISOString(),
        to: moment.utc().endOf('month').toISOString()
      },
      investmentsDates: {
        from: moment.utc().subtract(1, 'year').startOf('day').toISOString(),
        to: moment.utc().endOf('day').toISOString()
      },
      accountStatementMonth: Math.max(moment.utc().subtract(1, "month"), moment(this.props.account.createdAt).utc())
    }
  }

  onFilterDateRangeChange = key => ([dateFrom, dateTo]) => {
    this.setState({
      [key]: {
        from: dateFrom ? dateFrom.startOf('day').toISOString() : "",
        to: dateTo ? dateTo.endOf('day').toISOString() : ""
      }
    });
  };

    onAccountStatementMonthChange = key => (month) => {
    this.setState({
      accountStatementMonth: month
    })

  }


  onTaxMonthChange = key => (month) => {
    const taxDate = month
      ? (key === 'from' ? month.clone().startOf('month') : month.clone().endOf('month')).toISOString()
      : "";

    this.setState({
      taxDates: {
        ...this.state.taxDates,
        [key]: taxDate
      }
    });
  }


  disabledMonth = current => {
    //no transactions in system before this date
      let transactionsDeployedDate = new Date("2021-06-28")
      let disabledBefore = moment(this.props.account.createdAt).isAfter(transactionsDeployedDate) ? this.props.account.createdAt : transactionsDeployedDate
      return current.valueOf() < new Date(disabledBefore)
  }


  disabledTaxMonth = (current) => {
    const minMonth = moment.utc().subtract(4, 'years').startOf('year');
    const maxMonth = moment.utc().endOf('month');

    return current && (
      current.clone().endOf('month').isBefore(minMonth) ||
      current.clone().startOf('month').isAfter(maxMonth)
    );
  }

  render(){

    const { token, account } = this.props;
    return (
      <div>
        {
          account.role === accountRoles.DEBTOR &&
          <Col className="withdraw-funds-wrapper ">

              <div className="panel-wrapper">
                <TransactionsSummary />
              </div>
          </Col>
        }

          {
            account.role === accountRoles.CREDITOR &&

          <Row className="withdraw-funds-wrapper ">
            <Col className="withdraw-funds-wrapper col-xs-12 col-md-6 ">
              <div className="panel-wrapper">
                <TransactionsSummary />
              </div>
            </Col>
            <Col className="panel-wrapper col-xs-12 col-md-6">
              <div style={{ display: 'inline-block' }}>
                <div>
                  <div style={{ marginBottom: 15, textAlign: 'left' }}>
                    <h2>Export pre daňové účely</h2>
                  </div>

                  <MonthPicker
                    onChange={this.onTaxMonthChange('from')}
                    format="MM.YYYY"
                    disabledDate={this.disabledTaxMonth}
                    style={Object.assign({ marginRight: 15 }, { float: 'left' })}
                    defaultValue={moment.utc(this.state.taxDates.from)}
                  />
                  <MonthPicker
                    onChange={this.onTaxMonthChange('to')}
                    format="MM.YYYY"
                    disabledDate={this.disabledTaxMonth}
                    style={Object.assign({ marginRight: 15 }, { float: 'left' })}
                    defaultValue={moment.utc(this.state.taxDates.to)}
                  />

                  <OpenFileLink
                    isButton
                    href={`${process.env.REACT_APP_API_URL}/loan/reportPaymentInvestor?token=${token}&accountId=${this.props.account.id}&dateFrom=${this.state.taxDates.from}&dateTo=${this.state.taxDates.to}`}
                    style={{ marginLeft: 15 }}
                    classNames="primary"
                  >
                    Export
                  </OpenFileLink>
                </div>
                <br />
                <br />
                <div>
                  <div style={{ marginBottom: 15, textAlign: 'left' }}>
                    <h2>Export investícií</h2>
                  </div>

                  <RangePicker
                    onChange={this.onFilterDateRangeChange('investmentsDates')}
                    format="DD.MM.YYYY"
                    style={Object.assign({ marginRight: 15 }, { float: 'left' })}
                    defaultValue={[
                      moment.utc(this.state.investmentsDates.from),
                      moment.utc(this.state.investmentsDates.to),
                    ]}
                  />

                  <OpenFileLink
                    isButton
                    href={`${process.env.REACT_APP_API_URL}/loan/reportInvestmentsStatus?token=${token}&accountId=${this.props.account.id}&dateFrom=${this.state.investmentsDates.from}&dateTo=${this.state.investmentsDates.to}`}
                    style={{ marginLeft: 15 }}
                    classNames="primary"
                  >
                    Export
                  </OpenFileLink>
                </div>
            <div>
              <br/>
              <br/>
          <div style={{ marginBottom: 15, textAlign: 'left'  }}><h2>Export výpisu z účtu</h2></div>

          <MonthPicker
            onChange={this.onAccountStatementMonthChange()}
            picker="month"
            format="MM.YYYY"
            disabledDate={this.disabledMonth}
            style={Object.assign({ marginRight: 15 }, { float: 'left' })}
            defaultValue={moment.utc(this.state.accountStatementMonth)}
          />

          <OpenFileLink
            isButton
            href={`${process.env.REACT_APP_API_URL}/account/accountStatement?token=${token}&accountId=${this.props.account.id}&month=${this.state.accountStatementMonth}`}
            style={{ marginLeft: 15 }}
            classNames="primary"
          >
            Export
          </OpenFileLink>
        </div>
            </div>
          </Col>
          </Row>
          }

        <br/>
        <Row>
            <Col xs={12}>
                <PreviewTransactionsList />
            </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/transactions/containers/TransactionsPreviewContainer.js